/**
 * Logger 인스턴스
 * Feature-Sliced Design: shared/lib/logger
 *
 * Consola 기반의 재사용 가능한 logger 인스턴스
 */

import { createConsola } from 'consola';
import { defaultConfig, getLevelNumber } from './config';
import type { Logger } from './types';

/**
 * 전역 logger 인스턴스
 *
 * 사용 예시:
 * ```typescript
 * import { logger } from '@/shared/lib';
 *
 * logger.info('User logged in');
 * logger.error('Failed to fetch data', error);
 * logger.success('Operation completed');
 *
 * const wsLogger = logger.withTag('websocket');
 * wsLogger.debug('Connection established');
 * ```
 */
export const logger = createConsola({
  level: getLevelNumber(defaultConfig.level),
}) as Logger;

/**
 * 개발 환경에서만 전역 console 래핑
 * 이렇게 하면 기존 console.log도 consola 포맷으로 출력됨
 * (선택적 기능이므로 필요시 주석 해제)
 */
// if (import.meta.env.DEV) {
//   logger.wrapAll();
// }

/**
 * Default export (both named and default export supported)
 */
export default logger;
